<template>
  <div>
    <v-row dense>
      <span class="slide">
        Note* : File size should be less than {{ sizelimit / 1000000 }}MB! and File should be in
            <span v-for="(type, index) in allowed_extensions" in :key="index">
              {{ type }}</span
            >
            Format!
      </span>
    </v-row>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-toolbar flat dense class="toolbar">
      <v-toolbar-title>Research Details</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="instructor_research_list"
      class="elevation-1 mytable"
      dense
      :search="search"
    >
      <template v-slot:top>
        <v-toolbar flat dense color="white">
        
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          >
          </v-text-field>
          <span style="width: 20px"></span>
          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on }">
              <v-btn class="button" v-on="on" small
                >Add Research Details</v-btn
              >
            </template>
            <v-card>
              <v-card-title class="toolbar">
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="title"
                        label="Title *"
                        placeholder="Please enter Title"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="title"
                        label="Title *"
                        placeholder="Please enter Title"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                      <v-textarea
                        rows="2"
                        clearable
                        counter
                        label="Description"
                        :rules="rules"
                        outlined
                        v-model="description"
                      ></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                      <v-textarea
                        clearable
                        rows="2"
                        counter
                        label="Description"
                        :rules="rules"
                        outlined
                        v-model="description"
                      ></v-textarea>
                    </v-col>

                    <v-col sm="4" v-if="editedIndex == -1">
                            <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        rounded
                                        v-model="dateFormatted"
                                        :rules="dateFormatted==null || dateFormatted==''? [' Date is required']
                                            : []
                                        "
                                        label="From Date *"
                                        hint="DD/MM/YYYY format"
                                        persistent-hint
                                        outlined
                                        @blur="date2 = parseDate(dateFormatted)"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="date2" no-title @input="menu2 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col sm="4" v-if="editedIndex != -1">
                            <v-menu ref="menu2_edit" v-model="menu2_edit" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        rounded
                                        v-model="dateFormatted_edit"
                                        :rules="dateFormatted_edit==null || dateFormatted_edit==''? [' Date is required']
                                            : []
                                        "
                                        label="From Date *"
                                        hint="DD/MM/YYYY format"
                                        persistent-hint
                                        outlined
                                        @blur="date2_edit = parseDate(dateFormatted_edit)"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="date2_edit" no-title @input="menu2_edit = false"></v-date-picker>
                            </v-menu>
                        </v-col>


                        <v-col sm="4" v-if="editedIndex == -1">
                            <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        rounded
                                        v-model="dateFormatted_end"
                                        :rules="dateFormatted_end==null || dateFormatted_end==''? [' Date is required']
                                            : []
                                        "
                                        label="End Date *"
                                        hint="DD/MM/YYYY format"
                                        persistent-hint
                                        outlined
                                        @blur="date2_end = parseDate(dateFormatted_end)"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="date2_end" no-title @input="menu1 = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col sm="4" v-if="editedIndex != -1">
                            <v-menu ref="menu1_edit" v-model="menu1_edit" :close-on-content-click="false" transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        dense
                                        rounded
                                        v-model="edit_dateFormatted_end"
                                        :rules="edit_dateFormatted_end==null || edit_dateFormatted_end==''? [' Date is required']
                                            : []
                                        "
                                        label="End Date"
                                        hint="DD/MM/YYYY format"
                                        persistent-hint
                                        outlined
                                        @blur="edit_dateFormatted_end = parseDate(edit_dateFormatted_end)"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="edit_date2_end" no-title @input="menu1_edit = false"></v-date-picker>
                            </v-menu>
                        </v-col>
                        

                    <v-col cols="4" sm="4" md="4" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="source"
                        label="Source"
                        placeholder="Please enter Source"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="source"
                        label="Source"
                        placeholder="Please enter Source"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4" v-if="editedIndex == -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="publicationlink"
                        label="Publication Link"
                        placeholder="Please enter Publication Link"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        rounded
                        outlined
                        v-model="publicationlink"
                        label="Publication Link"
                        placeholder="Please enter Publication Link"
                      ></v-text-field>
                    </v-col>

                    <v-col
                      cols="4"
                      sm="4"
                      md="4"
                      v-if="editedIndex != -1 && research_letter != 'NA'"
                    >
                      Previous File :
                      <a :href="aws_path + research_letter" target="_blank">
                        View</a
                      >
                    </v-col>
                    

                    <v-col cols="4" sm="4" md="4" v-if="editedIndex == -1">
                      <v-file-input
                        rounded
                        label="Research Document"
                        outlined
                        dense
                        placeholder="Optional"
                        v-model="research_letter"
                        @change="validateResearchLetter()"
                        :hint="research_letter == null ? 'File should be in given format' : 'File selected'"
                      ></v-file-input>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="editedIndex != -1">
                      <v-file-input
                        rounded
                        label="Research Document"
                        outlined
                        dense
                        placeholder="Optional"
                        v-model="edit_research_letter"
                        @change="validateEditResearchLetter()"
                        :hint="edit_research_letter == null ? 'File should be in given format' : 'File selected'"
                      ></v-file-input>
                    </v-col>
                    
                    <v-col cols="4" sm="4" md="4" v-if="editedIndex == -1">
                     <v-text-field
                        dense
                        type="number"
                        rounded
                        outlined
                        v-model="amount"
                        label="Amount"
                        placeholder="Please enter Amount"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="editedIndex != -1">
                      <v-text-field
                        dense
                        type="number"
                        rounded
                        outlined
                        v-model="amount"
                        label="Amount"
                        placeholder="Please enter Amount"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="4" sm="4" md="4" v-if="editedIndex == -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        :items="research_type_list"
                        item-text="researchtype"
                        item-value="research_type_id"
                        v-model="researchtype"
                        label="Research Type *"
                        placeholder="Select Research Type"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="editedIndex != -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        :items="research_type_list"
                        item-text="researchtype"
                        v-model="researchtype"
                        label="Research Type *"
                        placeholder="Select Research Type"
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="4" sm="4" md="4" v-if="editedIndex == -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        :items="research_status_list"
                        item-text="researchstatus"
                        item-value="research_status_id"
                        v-model="researchstatus"
                        label="Research Status *"
                        placeholder="Select Research Status"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="4" sm="4" md="4" v-if="editedIndex != -1">
                      <v-autocomplete
                        dense
                        rounded
                        outlined
                        :items="research_status_list"
                        item-text="researchstatus"
                        v-model="researchstatus"
                        label="Research Status *"
                        placeholder="Select Research Status"
                      ></v-autocomplete>
                    </v-col>

                    <!-- <v-col cols="6" sm="6" md="6" v-if="editedIndex == -1">
                      <v-checkbox
                        v-model="iscurrentjob"
                        label="isCurrentJob"
                        color="success"
                        hide-details
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="6" sm="6" md="6" v-if="editedIndex != -1">
                      <v-checkbox
                        v-model="iscurrentjob"
                        label="isCurrentJob"
                        color="success"
                        hide-details
                      ></v-checkbox>
                    </v-col> -->
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="button" @click="close">Cancel</v-btn>
                <v-btn class="button" @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>

      <!-- <template v-slot:item.iscurrentjob="{ item }">
        <span v-if="item.iscurrentjob">
          <v-icon class="mr-2 v-icon-size" color="success"
            >mdi-check-circle-outline</v-icon
          >
        </span>
        <span v-else>
          <v-icon class="mr-2 v-icon-size" color="error"
            >mdi-close-circle-outline</v-icon
          >
        </span>
      </template> -->

      <template v-slot:item.publicationlink="{ item }">
        <span v-if="item.publicationlink != 'null'">
          <a :href="item.publicationlink" target="_blank"> link</a>
        </span>
        <span v-else> NA </span>
      </template>

      <template v-slot:item.research_letter="{ item }">
        <span v-if="item.research_letter != 'NA'">
          <a :href="aws_path + item.research_letter" target="_blank"> View </a>
        </span>
        <span v-else> NA </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)"
              >edit</v-icon
            >
          </v-avatar>
          <v-avatar style="" size="20" class="edit-avatar">
            <v-icon
              color="error"
              class="delete-v-icon mr-2"
              @click="deleteItem(item)"
              >delete</v-icon
            >
          </v-avatar>
        </div>
      </template>
    </v-data-table>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-center">
      <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please wait..
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  props: {
    instid: Number,
  },
  data() {
    return {
      overlay: false,
      dialog_upload: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search: "",
      dialog: false,
      rules: [v => v.length <= 250 || 'Max 250 characters'],
      errorMsg: {
        title: false,
      },
      headers: [
        {
          text: "Sr. No.",
          align: "left",
          sortable: false,
          value: "srno",
        },

        {
          text: "Title",
          align: "left",
          sortable: false,
          value: "title",
        },
        {
          text: "Description",
          align: "left",
          sortable: true,
          value: "description",
        },
        {
          text: "Source",
          align: "left",
          sortable: true,
          value: "source",
        },
        {
          text: "Publication Link",
          align: "left",
          sortable: true,
          value: "publicationlink",
        },
        {
          text: "Documet",
          align: "left",
          value: "research_letter",
        },
        {
          text: "Ammount",
          align: "left",
          value: "amount",
        },
        {
          text: "From Date",
          align: "left",
          value: "date2",
        },
        {
          text: "To Date",
          align: "left",
          value: "date2_end",
        },
        {
          text: "Research Type",
          align: "left",
          value: "researchtype",
        },
        {
          text: "Research Status",
          align: "left",
          value: "researchstatus",
        },
        { text: "Actions", value: "action", sortable: false },
      ],
      editedIndex: -1,
      instructor_research_list: [],
      research_type_list: [],
      research_status_list: [],
      title: null,
      researchtype: null,
      researchstatus: null,
      description: '',
      source: null,
      id: null,
      amount: null,
      research_letter: null,
      edit_research_letter: null,
      aws_path: null,
      sizelimit: null,
      publicationlink: null,
      allowed_extensions: [],
      size_flag:false,
      ext_flag:false,
      menu2: false,
      menu2_edit: false,
      menu1: false,
      menu1_edit: false,
      display_size:null,
      dateFormatted_edit:'',
      dateFormatted:'',
      dateFormatted_end:'',
      edit_dateFormatted_end:'',
      date2: new Date().toISOString().substr(0, 10),
      date2_edit: '',
      date2_end: new Date().toISOString().substr(0, 10),
      edit_date2_end: '',
    };
  },
  watch: {
    date2(val) {
                this.dateFormatted = this.formatDate(this.date2);
            },
    date2_end(val) {
                this.dateFormatted_end = this.formatDate(this.date2_end);
            },
    date2_edit(val) {
                this.dateFormatted_edit = this.formatDate(this.date2_edit);
            },
    edit_date2_end(val) {
                this.edit_dateFormatted_end = this.formatDate(this.edit_date2_end);
            },
    instid() {
      this.getData();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Research Details"
        : "Edit Research Details";
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      const formData = {
        instid: this.instid,
      };
      axios
        .post("/EmployeeProfile/getEmployeeResearch", formData)
        .then((res) => {
          if (res.data.msg == "200") {
            this.instructor_research_list =
              res.data.instructor_research_list;
            this.allowed_extensions = res.data.allowed_extensions;
            this.sizelimit = res.data.sizelimit;
            this.display_size = this.sizelimit/1000
            this.aws_path = res.data.aws_path;
            this.research_type_list = res.data.research_type_list;
            this.research_status_list = res.data.research_status_list;
          } else {
            // alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar(
                "#b71c1c",
                "Something went wrong!!!"
              );
          // alert("Somthing went wrong!!!");
        })
        .finally(() => {
          // this.comp_load = false;
        });
    },

    validateResearchLetter() {
      let file1 = this.research_letter;
      let file_size = file1.size;
      let file_name = this.research_letter.name;
      let ext = file_name.split(".").pop();
      if (file_size > this.sizelimit) {
        this.size_flag = true;
        this.showSnackbar(
                "#b71c1c",
                "File should be less than " + this.sizelimit/1000000 +"MB!!!"
              );
        this.research_letter = null;
      } else {
        this.size_flag = false;
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext == this.allowed_extensions[i]) {
          this.ext_flag = false;
          return;
        }
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext != this.allowed_extensions[i]) {
          this.ext_flag = true;
          this.showSnackbar(
                "#b71c1c",
                "File should be in " + this.allowed_extensions +" format!!!"
              );
          this.research_letter = null;
          return;
        }
      }
      
    },
    validateEditResearchLetter() {
        let file1 = this.edit_research_letter;
      let file_size = file1.size;
      let file_name = this.edit_research_letter.name;
      let ext = file_name.split(".").pop();
      if (file_size > this.sizelimit) {
        this.size_flag = true;
        this.showSnackbar(
                "#b71c1c",
                "File should be less than " + this.sizelimit/1000000 +"MB!!!"
              );
        this.edit_research_letter = null;
      } else {
        this.size_flag = false;
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext == this.allowed_extensions[i]) {
          this.ext_flag = false;
          return;
        }
      }
      for (var i = 0; i < this.allowed_extensions.length; i++) {
        if (ext != this.allowed_extensions[i]) {
          this.ext_flag = true;
          this.showSnackbar(
                "#b71c1c",
                "File should be in " + this.allowed_extensions +" format!!!"
              );
          this.edit_research_letter = null;
          return;
        }
      }
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.instructor_research_list.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.title = item.title;
      this.description = item.description;
      this.id = item.id;
      this.source = item.source;
      this.amount = item.amount;
      this.publicationlink = item.publicationlink;
      this.research_letter = item.research_letter;
      this.researchtype = item.researchtype;
      this.researchstatus = item.researchstatus;
      this.dateFormatted_edit = item.date2;
      this.edit_dateFormatted_end = item.date2_end;
      this.dialog = true;
    },
    isValidated() {
      if (this.title) {
        return true;
      } else {
        if (!this.title) {
          this.errorMsg.title = true;
        }

        return false;
      }
    }, // .....end of isValidated()
    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          if (this.title == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter Title!!!"
              );
              return false
        }
        else if (this.description.length > 250) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter description in 250 characters!!!"
              );
              return false
        }
        else if (this.dateFormatted_edit == '') {
          this.showSnackbar(
                "#b71c1c",
                "Please select From Date!!!"
              );
              return false
        }
        else if (this.edit_dateFormatted_end == '') {
          this.showSnackbar(
                "#b71c1c",
                "Please select To Date!!!"
              );
              return false
        }
        else if (this.researchtype == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please select Research type!!!"
              );
              return false
        }
        else if (this.researchstatus == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter Research status!!!"
              );
              return false
        }
        else{
          this.dialog_upload = true
          let formData = new FormData();
          formData.append("instid", this.instid);
          formData.append("title", this.title);
          formData.append("description", this.description);
          formData.append("id", this.id);
          formData.append("source", this.source);
          formData.append("amount", this.amount);
          formData.append("publicationlink", this.publicationlink);
          formData.append("research_letter", this.edit_research_letter);
          formData.append("researchtype", this.researchtype);
          formData.append("researchstatus", this.researchstatus);
          formData.append("fromDate", this.dateFormatted_edit);
          formData.append("toDate", this.edit_dateFormatted_end);
          axios
            .post("/EmployeeProfile/editEmployeeResearch", formData)
            .then((res) => {
              if (res.data.msg == "200") {
                if (res.data.status.code == "SUCCESS") {
                  this.showSnackbar(
                  "#4caf50",
                  "Research details updated successfully..."
                ); // show snackbar on success
                }else{
                  this.showSnackbar(
                  "#b71c1c",
                  "Research details already present!!!"
                ); // show snackbar on success
                }
                
                this.getData();
                this.dialog_upload = false
              }
            })
            .catch((error) => {
              this.showSnackbar(
                "#b71c1c",
                "Something went wrong!!!"
              );
              window.console.log(error);
            })
            .finally(() => {
              this.title = null;
              this.description = '';
              this.source = null;
              this.amount = null;
              this.publicationlink = null;
              this.edit_research_letter = null;
              this.researchtype = null;
              this.researchstatus = null;
              this.dateFormatted_edit = '';
              this.edit_dateFormatted_end = '';
            });

          this.close();
        }
      }
      } else {
        if (this.title == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter Title!!!"
              );
              return false
        }
        else if (this.description.length > 250) {
          this.showSnackbar(
                "#b71c1c",
                "Please enter description in 250 characters!!!"
              );
              return false
        }
        else if (this.dateFormatted == '') {
          this.showSnackbar(
                "#b71c1c",
                "Please select From Date!!!"
              );
              return false
        }
        else if (this.dateFormatted_end == '') {
          this.showSnackbar(
                "#b71c1c",
                "Please select To Date!!!"
              );
              return false
        }
        else if (this.researchtype == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please select Research type!!!"
              );
              return false
        }
        
        else if (this.researchstatus == null) {
          this.showSnackbar(
                "#b71c1c",
                "Please select Research Status!!!"
              );
              return false
        }
        else{
          this.dialog_upload = true
        let formData = new FormData();
        formData.append("instid", this.instid);
        formData.append("title", this.title);
        formData.append("description", this.description);
        formData.append("id", this.id);
        formData.append("source", this.source);
        formData.append("amount", this.amount);
        formData.append("publicationlink", this.publicationlink);
        formData.append("research_letter", this.research_letter);
        formData.append("researchtype", this.researchtype);
        formData.append("researchstatus", this.researchstatus);
        formData.append("fromDate", this.dateFormatted);
        formData.append("endDate", this.dateFormatted_end);
        axios
          .post("/EmployeeProfile/saveEmployeeResearch", formData)
          .then((res) => {
            if (res.data.status.code == "SUCCESS") {
              this.showSnackbar(
                "#4caf50",
                "Research details added successfully..."
              ); // show snackbar on success
              this.getData();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar(
                "#b71c1c",
                "Research details already present!!!"
              ); // show snackbar on error
            }
            this.dialog_upload = false
          })
          .catch((error) => {
            this.showSnackbar(
                "#b71c1c",
                "Something went wrong!!!"
              );
            window.console.log(error);
          })
          .finally(() => {
            this.title = null;
            this.description = '';
            this.source = null;
            this.amount = null;
            this.publicationlink = null;
            this.research_letter = null;
            this.researchtype = null;
            this.researchstatus = null;
            this.dateFormatted = null;
            this.dateFormatted_end = null;
          });

        this.close();
        }
      }
    },
    formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },

    deleteItem(item) {
      // alert("in delete : " + item.id);
      var result = confirm("Want to delete?");
      if (result) {
        const formData = {
          instid: this.instid,
          inst_research_id: item.id,
        };
        axios
          .post("/EmployeeProfile/deleteEmployeeResearch", formData)
          .then((res) => {
            if (res.data.msg == "200") {
              if (res.data.status.code == "SUCCESS") {
                this.showSnackbar(
                  "#4caf50",
                  " Research details deleted successfully..."
                );
              } else {
                this.showSnackbar(
                  "#b71c1c",
                  "Can not delete Research details!!!"
                );
              }
              this.getData();
            } else {
              this.showSnackbar("#b71c1c", "Please try again!!!");
            }
          })
          .catch((error) => {
            alert("Somthing went wrong!!!");
          })
          .finally(() => {
            // this.comp_load = false;
          });
      }
    },
    close() {
      this.dialog = false;
      this.title = null;
      this.description = '';
      this.source = null;
      this.amount = null;
      this.publicationlink = null;
      this.research_letter = null;
      this.edit_research_letter = null;
      this.researchtype = null;
      this.researchstatus = null;
      this.date2 = null;
      this.date2_end = null;
      this.dateFormatted = '';
      this.dateFormatted_end = '';
      this.edit_dateFormatted_end = '';
      this.dateFormatted_edit = '';
      this.editedIndex = -1;
      // setTimeout(() => {
      //   this.editedItem = Object.assign({}, this.defaultItem);
      //   this.editedIndex = -1;
      // }, 300);
    },
  },
};
</script>
<style scoped>
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
  font-size: 80%;
}

</style>